import DeliverySettings from './DeliverySettingsContainer';

export default DeliverySettings;
